var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{
		transparent: _vm.isTransparentBackground,
		'is-external-dialog': _vm.isExternalDialog,
		'dialog-active': _vm.isDialogOpen,
		[_vm.osTypeClass]: true,
		'settings-dialog-active': _vm.isSettingsDialogOpen,
	},attrs:{"id":"app"}},[_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }